import currentUserPreload from "shared/current-user-preload"
import currentUserSelect from "shared/current-user-select"
import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

Devise.addUserScope("user", {
  query: User
    .ransack()
    .preload(currentUserPreload)
    .select(currentUserSelect)
})
